import { render, staticRenderFns } from "./Sights.vue?vue&type=template&id=b50b5162&scoped=true&"
import script from "./Sights.vue?vue&type=script&lang=js&"
export * from "./Sights.vue?vue&type=script&lang=js&"
import style0 from "./Sights.vue?vue&type=style&index=0&id=b50b5162&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50b5162",
  null
  
)

export default component.exports